import { render, staticRenderFns } from "./AdminMarketPlaceProductCard.vue?vue&type=template&id=cd87c33e&scoped=true"
import script from "./AdminMarketPlaceProductCard.vue?vue&type=script&lang=js"
export * from "./AdminMarketPlaceProductCard.vue?vue&type=script&lang=js"
import style0 from "./AdminMarketPlaceProductCard.vue?vue&type=style&index=0&id=cd87c33e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd87c33e",
  null
  
)

export default component.exports